export default [
    {
        path: '/fs',
        name: 'fotosmile-entry',
        component: () => import(/* webpackChunkName: "fotosmile" */ '../domain/fotosmile/FotosmileEntry.vue'),
    },
]
